import { COLOR_PALETTE } from 'constants/ui';
import { getConditionalObject } from 'utils/data';

import { ChangeKindFilter } from '../../../../PendingChangesDrawer.constants';

export const countsStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  flexShrink: 0,
};

const countStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxSizing: 'border-box',
  minWidth: '26px',
  height: '22px',
  padding: '0 6px',
  borderRadius: '11px',
  fontSize: '1.1rem',
  fontWeight: 600,
};

const interactiveCountStyles = {
  cursor: 'pointer',
};

const smallCountStyles = {
  minWidth: '22px',
  height: '18px',
  padding: '0 4px',
  fontSize: '1rem',
};

const directCountStyles = {
  backgroundColor: ({ palette }) => palette.background.hoverDefault,
  color: 'text.secondary',
};

const recalculatedCountStyles = {
  backgroundColor: 'transparent',
  border: ({ palette }) => `1px solid ${palette.border.default}`,
  color: 'text.secondary',
};

// The selected row has a light brand background in both themes, so its other count takes the brand color.
const selectedRowDirectCountStyles = {
  backgroundColor: COLOR_PALETTE.BRAND[2],
  color: COLOR_PALETTE.BRAND[7],
};

const selectedRowRecalculatedCountStyles = {
  borderColor: COLOR_PALETTE.BRAND[7],
  color: COLOR_PALETTE.BRAND[7],
};

const activeCountStyles = {
  backgroundColor: COLOR_PALETTE.BRAND[7],
  borderColor: COLOR_PALETTE.BRAND[7],
  color: COLOR_PALETTE.GRAY[1],
};

export const getCountStyles = ({ kind, isSmall, isRowSelected, isInteractive, isActive }) => {
  const isRecalculated = kind === ChangeKindFilter.RECALCULATED;

  return {
    ...countStyles,
    ...getConditionalObject(isSmall, smallCountStyles),
    ...getConditionalObject(isInteractive, interactiveCountStyles),
    ...(isRecalculated ? recalculatedCountStyles : directCountStyles),
    ...getConditionalObject(isRowSelected, () =>
      isRecalculated ? selectedRowRecalculatedCountStyles : selectedRowDirectCountStyles,
    ),
    ...getConditionalObject(isActive, activeCountStyles),
  };
};

export const getEmptyCountStyles = (isSmall, isRowSelected) => ({
  minWidth: isSmall ? '22px' : '26px',
  textAlign: 'center',
  color: isRowSelected ? COLOR_PALETTE.BRAND[7] : 'text.disabled',
});
